export default __webpack_public_path__ + "static/media/it.bc2ca2c6.png";